import { Node } from "tiptap";
import { setCellAttr } from "prosemirror-tables";

export default class TableBackgoundColor extends Node {
  get name() {
    return "tableBackgoundColor";
  }

  get schema() {
    return {
      // tableGroup: "block",
      // cellContent: "block+",
      // cellAttributes: {
			// 	// table cell color
      //   background: {
      //     default: null,
      //     getFromDOM(dom) {
      //       return dom.style.backgroundColor || null;
      //     },
      //     setDOMAttr(value, attrs) {
      //       if (value) {
      //         const style = { style: `${attrs.style || ""}background-color: ${value};` };
      //         Object.assign(attrs, style);
      //       }
      //     }, 
      //   },
      // },
    };
  }

  commands({ schema }) {
    return {
      /* tiptap commands.setCellAttr() 동작 error로 인해 추가 */
      tableBackgroundColor: ({ name, value }) => setCellAttr(name, value),
    };
  }
}


// WEBPACK FOOTER //
// ./src/components/cowork/general/board/extensions/TableBackgroundColor.js